/*
 Created by CHT 2019/7/27 16:33
 */

// utils
import * as utils from './utils.js'

// 扩展方法
import RyFs from './FS/index.js'
import RyFsMinio from './FS_minio/index.js'
import RyUuid from './uuid/index.js'
// import RyFormSet from './RyFormSet/index.js'
import RySocket from './socket/index.js'

// 需要设置为全局组件的组件列表
// const components = [
// 	RyCropper
// ]

// 导出的方法组件属性等
const RyForm = {
	utils,
  RyFsMinio,
	RyFs,
	RyUuid,

	RySocket
}

export default {
	install(Vue, opts) {
		Vue.prototype.$RyForm = RyForm

		Vue.prototype.$RyUuid = RyUuid
		// Vue.prototype.$RyFs = RyFs
    Vue.prototype.$RyFs = RyFsMinio
		Vue.prototype.$RySocket = RySocket
		Vue.prototype.$Socket = new RySocket()

		// components.forEach(component => {
		// 	Vue.component(component.name, component)
		// })
	}
}
